




































































































import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import BasicHelperMixin from '@/components/helpers/basic-helper-mixin';
import { MoveDirectionEnum } from '@/services/models/Enums';
import FlowMixin from '@/views/reports/forms/flow/mixins/flow-mixin';
import ErrorMixin from '@/components/helpers/error-mixin';

import FlowNavigationRule from './flow-navigation-rule.vue';
import FlowNavigationPath from './flow-navigation-path.vue';

import FlowPathErrorsMixin, { RuleError } from '@/views/reports/forms/flow/mixins/flow-path-errors-mixin';

@Component({
  components: {
    FlowNavigationRule,
    FlowNavigationPath
  }
})
export default class FlowNavigation extends mixins(BasicHelperMixin, FlowMixin, FlowPathErrorsMixin) {
  @Prop()
  value: any;

  @Prop()
  activeRule: any;

  @Prop()
  formErrors: any;

  @Prop({
    default: function() {
      return (this as FlowNavigation).t('Create Flow');
    }
  }) header: string;

  @Prop()
  view: string;

  @Prop()
  countryName: string;

  @Prop()
  form: any;

  @Emit('update:view')
  onUpdateView(value: string) {}

  @Emit('set-placeholder')
  onSetPlaceholder(value: string) {}

  @Emit('add-path')
  onAddPath(path: any, cb: Function) {}

  @Emit('add-rule')
  onAddRule() {}

  active_item: any = null;
  isListRenderFinished: boolean = false;

  @Watch('activeRule', { deep: true })
  onActiveItemConditionsChanged(value: any, oldValue: any) {
    this.onSetPlaceholder(this.generate_name(value));
  }

  @Watch('form.rules')
  onFormRulesChanged() {
    this.isListRenderFinished = false;
  }

  havigationErrors: RuleError[] = [];
  //havigationErrorsRulesIndex: { [types: string]: any } = {};

  @Watch('errorsRaw', { immediate: true })
  onErrorsRawChanged() {
    this.havigationErrors = this.getRulesErrors(this.form.rules);
  }

  get havigationErrorsRulesIndex() {
    return this.havigationErrors.map((item) => ({
      hasError: item.hasError,
      hasPathError: item.paths.some((path) => path.hasError)
    }));
  }

  get havigationErrorsPathsIndex() {
    let result: {[type: string]: boolean} = {};
    this.havigationErrors
      .map((rule, ruleIndex) =>
        rule.paths
          .map((path, pathIndex) => ({
              ruleIndex: ruleIndex,
              pathIndex: pathIndex,
              hasError: path.hasError
            }))
      )
      .reduce((a, b) => a.concat(b), [])
      .forEach((item) => {
        result[this.getNavigationIndexKey(item.ruleIndex, item.pathIndex)] = item.hasError;
      });

      return result;
  }

  get nameDescriptionCountryName() {
    return this.countryName || this.t('Global');
  }

  get nameDescriptionName() {
    return this.form.name || this.t('None');
  }

  get nameDescription() {
    return `${this.nameDescriptionCountryName} - ${this.nameDescriptionName}`;
  }


  get isGeneralError() {
    return this.getInvalidFieldsError([ 'rules' ], [], true);
  }

  getNavigationIndexKey(ruleIndex: number, pathIndex: number) {
    return `${ruleIndex}_${pathIndex}`;
  }

  navigationHidden: boolean = false;
  subGroup: boolean = false;

  mounted() {
    this.$set(this.form.rules[0], 'active', true);
    this.isListRenderFinished = false;
  }

  openNavigation() {
    // this.navigationHidden = true;
    // this.subGroup = true;
    // this.$nextTick(() => {
    //   this.form.rules.forEach((rule: any, ruleIndex: number) => {
    //     //@ts-ignore
    //     this.$refs['group_' + ruleIndex][0].isActive = true
    //   });

    //   this.navigationHidden = false;
    //   this.subGroup = true;
    // });
  }

  handleMoveRule(index: number, direction: MoveDirectionEnum) {
    this.moveRule(index, this.form.rules, direction);
  }

  blockExpand(ruleIndex: number) {
    //@ts-ignore
    let isActive = this.$refs['group_' + ruleIndex][0].isActive;

    this.$nextTick(() => {
      //@ts-ignore
      this.$refs['group_' + ruleIndex][0].isActive = isActive;
    })
  }

  expand(ruleIndex: number) {
    //@ts-ignore
    let isActive = this.$refs['group_' + ruleIndex][0].isActive;
    //@ts-ignore
    this.$refs['group_' + ruleIndex][0].isActive = !isActive;
  }

  selectFlowSettings() {
    this.onUpdateView('settings');
    this.active_item = null;
  }

  moveRule(index: number, items: any[], direction: MoveDirectionEnum = MoveDirectionEnum.up) {
    const ids = this.getSwapIndexes(index, items, direction);

    if (ids) {
      this.swap(items, ids);
    }
  }

  get groups() {
    if(this.isListRenderFinished) {
      return this.form.rules.map((rule: any, ruleIndex: number) =>
        //@ts-ignore
        this.$refs['group_' + ruleIndex] && this.$refs['group_' + ruleIndex][0]
      );
    }

    this.isListRenderFinished = false;

    this.$nextTick(() => {
      this.isListRenderFinished = true;
    });

    return null;
  }

  setRule(item: any, errors: any = undefined) {
    if (!item.default) {
      this.onUpdateView('rule-settings');
      this.active_item = item;

      this.$emit('set-rule', item);
      this.$emit('set-errors', errors);
    } else {
      this.setPath(item.paths[0], item);
    }
  }

  setPath(item: any, rule: any, errors: any = undefined) {
    this.$nextTick(() => {
      this.onUpdateView('path-settings');
      this.active_item = item;
      this.$emit('set-rule', rule);
      this.$emit('set-path', item);
      this.$emit('set-errors', errors);
    })
  }
}
